module.exports = __webpack_public_path__ + "img/11.5927c576.jpg";